module.exports = "\n<h1>\n    <img src=\"assets/logo.png\" alt=\"logo\" /><br />\n    Mi a te szeretetnyelved?\n</h1>\n\n<p class=\"text-center\">\n    <button class=\"btn btn-primary btn-lg\" (click)=\"startTest()\">Teszt indítása</button>\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/landing/landing.component.html
// module id = 146
// module chunks = 1